<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column label="Option fiscale" [derrors]="derrors">
                    <mat-select formControlName="optionFiscale">
                      @for (item of optionsFiscales; track item) {
                        <mat-option [value]="item.id">
                          {{ item.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </pr-input-column>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column label="Cas exceptionnel" [derrors]="derrors">
                    <mat-select formControlName="casExceptionnel">
                      @for (item of optionsCasExceptionnels; track item) {
                        <mat-option [value]="item.id">
                          {{ item.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </pr-input-column>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column label="Motifs" [derrors]="derrors">
                    <mat-select formControlName="motifs" multiple>
                      @for (item of optionsMotifs; track item) {
                        <mat-option [value]="item.id">
                          {{ item.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </pr-input-column>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-12">
                  <div style="width: calc(100% - 27px)">
                    <pr-input-date
                      formControlName="contractStartDate"
                      label="Date de début du contrat"
                      [derrors]="derrors"
                      [isDefault]="false"
                    ></pr-input-date>
                  </div>
                </div>
              </div>
              @if (showRppDates) {
                <div class="row">
                  <div class="col col-md-12">
                    <div style="width: calc(100% - 27px)">
                      <pr-input-date
                        formControlName="rppStartDate"
                        label="Mise en place des rachats programmés à compter du"
                        [derrors]="derrors"
                        [isDefault]="false"
                      ></pr-input-date>
                    </div>
                  </div>
                </div>
              }
              @if (showRppDates) {
                <div class="row">
                  <div class="col col-md-12">
                    <div style="width: calc(100% - 27px)">
                      <pr-input-date
                        formControlName="rppEndDate"
                        label="Arrêt des rachats programmés à compter du"
                        [derrors]="derrors"
                        [isDefault]="false"
                      ></pr-input-date>
                    </div>
                  </div>
                </div>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
